import * as React from "react";
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
import "../file/ReactFlexyTable.css";
import { callApi } from "../../utils/api";
import {
    ToastsContainer,
    ToastsContainerPosition,
    ToastsStore,
} from "react-toasts";
import moment from "moment";
import { hasPageAccess } from "../../utils/pagePermissionService";
import { getFileStatus } from "../../utils/fileStatus";

interface AllProps {
    history: any;
}

interface FileData {
    file_no: number;
    file_name: number;
    file_status: number;
    app_id: string;
    file_number: string;
    branch_id: number;
    branch_name: string;
    branch_email: string;
    borrower_name: string;
    bank_name: string;
    created_date: string;
    created_date_formatted: string;
    file_status_name: string;
    process_officer: string;
    query_raised_dt: string;
    total_emails: number;
    total_attachments: number;
    emails: Array<any>;
    /** From list API (get_status7_files_with_mails) – no email list returned */
    latest_email_received_at_formatted?: string;
    pending_inbound_queue_count?: number;
    pending_inbound_queue?: Array<{ queue_id: number; created_dt: string }>;
}

interface ApiResponse {
    success: boolean;
    message: string;
    total_files: number;
    files_returned: number;
    files_with_emails: number;
    total_emails: number;
    total_attachments: number;
    pagination: {
        current_page: number;
        limit: number;
        total_pages: number;
        has_next: boolean;
        has_previous: boolean;
    };
    files: FileData[];
}

interface FetchEmailResponse {
    success: boolean;
    message: string;
    data?: {
        details?: any[];
        total_files_processed?: number;
        total_emails_found?: number;
        total_new_emails?: number;
    };
    details?: any; // legacy shape (some endpoints may return details at top level)
}

declare var $: any;

class ReceivedQueryMail extends React.Component<AllProps> {
    limitList = [10, 20, 30, 50, 100];
    getBranchStorageKey = () => {
        const user: any = localStorage.getItem("user");
        const userDetails = user ? JSON.parse(user) : null;
        const userId = userDetails?.userId || "default";
        return `received_query_mail_branch_${userId}`;
    };

    getPersistedBranch = () => {
        return localStorage.getItem(this.getBranchStorageKey()) || "";
    };

    persistBranch = (branchId: string) => {
        localStorage.setItem(this.getBranchStorageKey(), branchId || "");
    };

    state = {
        selectVal: false,
        outreason: "",
        files: [],
        isLoading: false,
        isFetchingEmails: false,
        lawhandsBranches: [],
        page: 1,
        limit: 20,
        totalFiles: 0,
        totalPages: 0,
        totalDataCount: 0,
        filesWithEmails: 0,
        totalEmails: 0,
        totalAttachments: 0,
        branch_id: "",
        searchText: "",
    };

    async componentDidMount() {
        this.getOutTime();
        const hasHide = await hasPageAccess("In-Reason/Out-Reason Hide");
        if (!hasHide) {
            this.ouTime();
        }

        const status: any = localStorage.getItem("dashboard_status");
        if (status == 2) {
            this.sendBalanceMin();
        }

        this.getLawHandsBranches();
    }
    getLawHandsBranches = () => {
        callApi("GET", "get_branch.php")
            .then((res) => res.data)
            .then((response) => {
                const user: any = localStorage.getItem("user");
                const userDetails = user ? JSON.parse(user) : "";
                let lawhandsBranches = response.data || [];

                if (
                    lawhandsBranches.length > 0 &&
                    userDetails.role_id !== "1" &&
                    userDetails.my_branchs
                ) {
                    const myBranchList = userDetails.my_branchs.split(",");
                    lawhandsBranches = lawhandsBranches.filter((value) =>
                        myBranchList.includes(value.id),
                    );
                }

                const selectedBranchId =
                    (() => {
                        const persisted = this.getPersistedBranch();
                        const persistedExists = lawhandsBranches.some(
                            (b: any) => String(b.id) === String(persisted),
                        );
                        if (persisted && persistedExists) return persisted;
                        return lawhandsBranches && lawhandsBranches.length > 0
                            ? lawhandsBranches[0].id
                            : "";
                    })();

                this.setState(
                    {
                        lawhandsBranches,
                        branch_id: selectedBranchId,
                        page: 1,
                    },
                    () => {
                        if (selectedBranchId) {
                            this.persistBranch(String(selectedBranchId));
                            this.getFiles();
                            // Inbound mail is driven by webhook + queue; no bulk IMAP poll here.
                        } else {
                            this.setState({ files: [] });
                        }
                    },
                );
            })
            .catch((err) => {
                console.log({ err });
            });
    };


    sendBalanceMin() {
        const fileid1: any = localStorage.getItem("file_Id");
        let updatedRemainingTime: any = localStorage.getItem(
            "updatedRemainingTime"
        );
        let updatedtime = Math.round(updatedRemainingTime);
        const status: any = localStorage.getItem("dashboard_status");
        let obj = {
            file_id: JSON.parse(fileid1),
            balance_min: updatedtime,
            dashboard_status: status,
        };
        callApi("POST", "process_eod_insert.php", obj)
            .then((res) => res.data)
            .then((response) => {
                localStorage.removeItem("updatedRemainingTime");
            })
            .catch((err) => {
                console.log(err);
            });
    }

    fileout = (fileid1) => {
        let fileId = JSON.parse(fileid1);
        const loginuser: any = localStorage.getItem("user1");
        let req = {
            id: fileId,
            reason: "File Out",
            created_by: JSON.parse(loginuser),
        };
        callApi("POST", "time_update.php", req)
            .then((res) => res.data)
            .then((response) => {
                localStorage.removeItem("currentfileId");
                localStorage.removeItem("query_raised_status");
                localStorage.removeItem("file_completed_status");
            });
    };

    previousPop = () => {
        $("#out_reason").modal("show");
        $("#another-reason").modal("hide");
    };

    BacktoFile = () => {
        $("#out_reason").modal("hide");
        const fileid1: any = localStorage.getItem("currentfileId");

        this.props.history.push("/file-dashboard/" + JSON.parse(fileid1));
    };

    getOutTime = () => {
        let date = new Date();
        let stratTime = date.getTime();
        localStorage.setItem("startTime", JSON.stringify(stratTime));
        let outDate = date.toLocaleDateString();
        localStorage.setItem("OutDateGet", JSON.stringify(outDate));
        var Railway = date.getMinutes();
        if (Railway < 10) {
            var TotalMinutes = "0" + Railway;
            let ouTtime = date.getHours() + ":" + TotalMinutes;
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        } else {
            let ouTtime: any = date.getHours() + ":" + date.getMinutes();
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        }
    };

    ouTime = () => {
        if (localStorage.getItem("currentfileId")) {
            $("#out_reason").modal("show");
        }
    };

    outimeGet = () => {
        this.setState({ isLoading: true });
        const fileid1: any = localStorage.getItem("currentfileId");
        const userid1: any = localStorage.getItem("user1");
        const inreason: any = localStorage.getItem("in_reason");
        const intime: any = localStorage.getItem("IntimeGet");
        const outtime: any = localStorage.getItem("outtimeGet");
        const outdate: any = localStorage.getItem("OutDateGet");
        const secondsSpent = moment(outtime, "HH:mm").diff(
            moment(intime, "HH:mm"),
            "seconds"
        );
        let updatedRemainingTime: any = localStorage.getItem(
            "updatedRemainingTime"
        );
        let updatedtime = Math.round(updatedRemainingTime);
        const status: any = localStorage.getItem("dashboard_status");
        const insertId: any = localStorage.getItem("ProcessEodInsertID");
        if (this.state.outreason == "") {
            this.setState({ selectVal: true });
        } else {
            let obj = {
                file_id: JSON.parse(fileid1),
                user_id: JSON.parse(userid1),
                in_reason: JSON.parse(inreason),
                out_reason: this.state.outreason,
                intime: JSON.parse(intime),
                outtime: JSON.parse(outtime),
                insert_date: JSON.parse(outdate),
                total_seconds: secondsSpent,
                balance_min: updatedtime,
                dashboard_status: status,
                "insert_id": insertId
            };

            callApi("POST", "process_eod_insert.php", obj)
                .then((res) => res.data)
                .then((response) => {
                    this.setState({ isLoading: false });
                    localStorage.removeItem("updatedRemainingTime");
                    localStorage.removeItem("updatedRemainingTime");
                    localStorage.removeItem("currentfileId");
                    localStorage.removeItem("in_reason");
                    localStorage.removeItem("outreason");
                    localStorage.removeItem("IntimeGet");
                    localStorage.removeItem("OutDateGet");
                    $("#out_reason").modal("hide");
                    $("#another-reason").modal("hide");
                    ToastsStore.success("Your Reason Saved Successfully");
                    localStorage.removeItem("currentfileId");
                    localStorage.removeItem("query_raised_status");
                    localStorage.removeItem("file_completed_status");
                })
                .catch((err) => {
                    this.setState({ isLoading: false });
                    console.log(err);
                    ToastsStore.error("Your Reason Not Stored");
                });
        }
    };

    onchangeReason = (e: any) => {
        if (e.target.value == "Other") {
            this.setState({ in_reason: "", selectVal: false });
            $("#out_reason").modal("hide");
            $("#another-reason").modal("show");
        } else if (e.target.value == "select") {
            this.setState({ setResponse: false });
        } else {
            this.setState({ [e.target.name]: e.target.value, selectVal: false });
        }
    };

    onchange = (e: any) => {
        this.setState({
            [e.target.name]: e.target.value.replace(/\s+/g, " ").trim(),
            selectVal: false,
        });
    };

    getFiles = () => {
        const { branch_id, page, limit, searchText } = this.state;

        if (!branch_id) {
            ToastsStore.error("Branch information not found");
            return;
        }
        let req = {
            action: "get_status7_files_with_mails",
            branch_id: [branch_id],
            page: page,
            limit: limit,
            search_text: (searchText || "").trim(),
        };

        this.setState({ isLoading: true });

        callApi("POST", "fetch_query_received_mail_details.php", req)
            .then((res) => res.data)
            .then((response: ApiResponse) => {
                if (response.success) {
                    const { files, total_files, pagination, files_with_emails, total_emails, total_attachments } = response;

                    // Process files for table display
                    const processedFiles = files.map((file:any, index) => ({
                        s_no: ((page - 1) * limit) + index + 1,
                        file_id: file.file_no,
                        file_name: file.file_name,
                        app_id: file.app_id,
                        branch_name: file.branch_name,
                        borrower_name: file.borrower_name,
                        bank_name: file.bank_name,
                        created_date: file.created_date_formatted,
                        file_status: file.file_status,
                        total_emails: file.total_emails,
                        total_attachments: file.total_attachments,
                        emails: file.emails || [], // List API returns no emails; details load via get_file_with_emails
                        query_received_to: file.process_officer,
                        query_raised_dt: file.query_raised_dt
                            ? moment(file.query_raised_dt).format("DD MMM YYYY, hh:mm A")
                            : "",
                        received_dt: this.formatListMailReceivedDate(file),
                        latest_email_received_at_formatted: file.latest_email_received_at_formatted,
                        login_dt: file.created_dt
                            ? moment(file.created_dt).format("DD MMM YYYY, hh:mm A")
                            : (file.created_date_formatted || ""),
                        pending_inbound_queue_count: file.pending_inbound_queue_count ?? 0,
                        pending_inbound_queue: file.pending_inbound_queue ?? [],
                        mail_received_date_source: (file as any).mail_received_date_source,
                    }));

                    this.setState({
                        files: processedFiles,
                        totalFiles: total_files,
                        totalPages: pagination.total_pages,
                        totalDataCount: total_files,
                        filesWithEmails: files_with_emails,
                        totalEmails: total_emails,
                        totalAttachments: total_attachments,
                        isLoading: false
                    });
                } else {
                    ToastsStore.error(response.message || "Failed to load files");
                    this.setState({
                        files: [],
                        isLoading: false,
                        totalFiles: 0,
                        totalPages: 0,
                        totalDataCount: 0
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                ToastsStore.error("No files found");
                this.setState({
                    isLoading: false,
                    files: [],
                    totalFiles: 0,
                    totalPages: 0,
                    totalDataCount: 0
                });
            });
    };

    // NEW METHOD: Fetch emails from mail server
    fetchEmailsFromServer = () => {
        const { branch_id } = this.state;

        if (!branch_id) {
            ToastsStore.error("Branch information not found");
            return;
        }

        this.setState({ isFetchingEmails: true });

        const req = {
            action: "fetch_status7_emails",
            branch_id: [branch_id]
        };

        callApi("POST", "fetch_query_received_mail.php", req)
            .then((res) => res.data)
            .then((response: FetchEmailResponse) => {
                if (response.success) {
                    ToastsStore.success(response.message || "Emails fetched successfully!");

                    // Show summary toast (API returns summary in response.data)
                    const data: any = response.data || response;
                    const details = data?.details;
                    if (Array.isArray(details) && details.length > 0) {
                        const first = details[0];
                        const summaryMessage = `Processed ${first.total_files || 0} files, found ${first.total_emails || 0} emails (${first.new_emails_found || 0} new)`;
                        ToastsStore.info(summaryMessage);
                    } else if (data?.total_files_processed != null || data?.total_emails_found != null) {
                        const summaryMessage = `Processed ${data.total_files_processed ?? 0} files, found ${data.total_emails_found ?? 0} emails (${data.total_new_emails ?? 0} new)`;
                        ToastsStore.info(summaryMessage);
                    }

                    // Refresh the file list after successful fetch
                    setTimeout(() => {
                        this.getFiles();
                    }, 1000);
                } else {
                    ToastsStore.error(response.message || "Failed to fetch emails");
                }
            })
            .catch((err) => {
                console.log(err);
                ToastsStore.error("Error fetching emails from server");
            })
            .finally(() => {
                this.setState({ isFetchingEmails: false });
            });
    };

    /** Prefer API formatted date, else latest tbl_mail_inbound_queue created_dt, else emails / fallback text. */
    formatListMailReceivedDate(file: any): string {
        if (file.latest_email_received_at_formatted) {
            return file.latest_email_received_at_formatted;
        }
        const pq = file.pending_inbound_queue;
        if (Array.isArray(pq) && pq.length > 0) {
            let latest: string | null = null;
            for (const row of pq) {
                if (row?.created_dt) {
                    if (!latest || new Date(row.created_dt) > new Date(latest)) {
                        latest = row.created_dt;
                    }
                }
            }
            if (latest) {
                return moment(latest).format("DD MMM YYYY, hh:mm A");
            }
        }
        return this.getLatestEmailDate(file as FileData);
    }

    // Helper: latest email date (list API sends latest_email_received_at_formatted; fallback when emails array present)
    getLatestEmailDate(file: FileData): string {
        if (file.latest_email_received_at_formatted) return file.latest_email_received_at_formatted;
        const pq = (file as any).pending_inbound_queue;
        if (Array.isArray(pq) && pq.length > 0) {
            let latest: string | null = null;
            for (const row of pq) {
                if (row?.created_dt) {
                    if (!latest || new Date(row.created_dt) > new Date(latest)) {
                        latest = row.created_dt;
                    }
                }
            }
            if (latest) {
                return moment(latest).format("DD MMM YYYY, hh:mm A");
            }
        }
        if (file.emails && file.emails.length > 0) {
            const latestEmail = file.emails[0];
            return latestEmail.received_at_formatted || (latestEmail.received_at ? moment(latestEmail.received_at).format('DD-MM-YYYY/HH:mm') : '');
        }
        return "No emails";
    }

    handlePageChange = (event: any, page: number) => {
        this.setState({ page }, () => {
            this.getFiles();
        });
    };

    handleLimitChange = (event: any) => {
        this.setState({
            limit: event.target.value,
            page: 1 // Reset to first page when limit changes
        }, () => {
            this.getFiles();
        });
    };

    handleBranchChange = (event: any) => {
        const branch_id = event.target.value;
        this.setState(
            {
                branch_id,
                page: 1,
            },
            () => {
                this.persistBranch(String(branch_id));
                this.getFiles();
            },
        );
    };

    handleSearchInputChange = (event: any) => {
        this.setState({ searchText: event.target.value });
    };

    applySearch = () => {
        this.setState({ page: 1 }, () => {
            this.getFiles();
        });
    };

    clearSearch = () => {
        this.setState(
            {
                searchText: "",
                page: 1,
            },
            () => {
                this.getFiles();
            },
        );
    };

    goToFileDashboard = (id) => {
        const url = "/unhold-file";
        localStorage.setItem("url", url);
        let obj = { file_id: id };
        localStorage.setItem("thisPopup", JSON.stringify(obj));
        localStorage.setItem("currentfileId", JSON.stringify(id));
        this.props.history.push("/file-dashboard/" + id);
    };

    getSelectedFile = (id) => {
        this.setState({ unholdFile: id });
    };

    goToFileDetails = (file) => {
        // Pass the complete file data to the details page
        this.props.history.push({
            pathname: `/received-query-details/${file.file_id}`,
            state: {
                fileDetails: file, // Pass the complete file object
                fromFileDashboard: false,
            }
        });
    }

    render() {
        const clickableStyle = {
            cursor: "pointer"
        };

        const columns = [
            {
                header: "S.No",
                key: "s_no",
                td: (file) => (
                    <span
                        style={clickableStyle}
                        onClick={() => this.goToFileDetails(file)}
                    >
                        {file.s_no}
                    </span>
                ),
            },
            {
                header: "File No",
                key: "file_name",
                td: (file) => (
                    <span
                        style={{ ...clickableStyle, color: "#1890ff" }}
                        onClick={() => this.goToFileDetails(file)}
                    >
                        {file.file_name}
                    </span>
                ),
            },
            {
                header: "App ID",
                key: "app_id",
                td: (file) => (
                    <span
                        style={clickableStyle}
                        onClick={() => this.goToFileDetails(file)}
                    >
                        {file.app_id}
                    </span>
                ),
            },
            {
                header: "Borrower Name",
                key: "borrower_name",
                td: (file) => (
                    <span
                        style={clickableStyle}
                        onClick={() => this.goToFileDetails(file)}
                    >
                        {file.borrower_name}
                    </span>
                ),
            },
            {
                header: 'Status',
                key: 'file_status',
                td: (file) => (
                    <span
                        style={clickableStyle}
                        onClick={() => this.goToFileDetails(file)}
                    >
                        {getFileStatus(file.file_status)}
                    </span>
                ),
            },
            {
                header: "Emails",
                key: "total_emails",
                td: (file: any) => {
                    const queued = file.pending_inbound_queue_count ?? 0;
                    const queuedHint =
                        queued > 0 && file.total_emails === 0
                            ? ` · ${queued} queued (webhook)`
                            : queued > 0
                              ? ` · +${queued} queued`
                              : "";
                    return (
                        <span
                            style={clickableStyle}
                            onClick={() => this.goToFileDetails(file)}
                            title={
                                queued > 0 && file.total_emails === 0
                                    ? "Mail received in inbound queue; open file to import into mailbox"
                                    : undefined
                            }
                        >
                            {file.total_emails} ({file.total_attachments}{" "}
                            {file.total_attachments === 1 ? "pending attachment" : "pending attachments"})
                            {queuedHint}
                        </span>
                    );
                },
            },
            {
                header: "Query Received To",
                key: "query_received_to",
                td: (file) => (
                    <span
                        style={clickableStyle}
                        onClick={() => this.goToFileDetails(file)}
                    >
                        {file.query_received_to}
                    </span>
                ),
            },
            {
                header: "Query Raised Date",
                key: "query_raised_dt",
                td: (file) => (
                    <span
                        style={clickableStyle}
                        onClick={() => this.goToFileDetails(file)}
                    >
                        {file.query_raised_dt}
                    </span>
                ),
            },
            {
                header: "Mail Received Date",
                key: "received_dt",
                td: (file: any) => {
                    const fromQueue =
                        file.mail_received_date_source === "pending_queue" ||
                        (!file.latest_email_received_at_formatted &&
                            Array.isArray(file.pending_inbound_queue) &&
                            file.pending_inbound_queue.length > 0);
                    return (
                        <span
                            style={clickableStyle}
                            onClick={() => this.goToFileDetails(file)}
                            title={
                                fromQueue
                                    ? "Date from inbound webhook queue (import pending)"
                                    : undefined
                            }
                        >
                            {file.received_dt}
                        </span>
                    );
                },
            },
            {
                header: "File Created Date",
                key: "login_dt",
                td: (file) => (
                    <span
                        style={clickableStyle}
                        onClick={() => this.goToFileDetails(file)}
                    >
                        {file.login_dt}
                    </span>
                ),
            }
        ];

        const {
            selectVal,
            files,
            isLoading,
            page,
            limit,
            totalPages,
            totalDataCount,
            isFetchingEmails,
            lawhandsBranches,
            branch_id,
            searchText,
        } = this.state;
        const noOfPages = totalPages;

        // Generate pagination numbers
        const getPaginationNumbers = () => {
            const numbers: any = [];
            const maxVisible = 5;
            let start: any = Math.max(1, page - Math.floor(maxVisible / 2));
            let end = Math.min(totalPages, start + maxVisible - 1);

            if (end - start + 1 < maxVisible) {
                start = Math.max(1, end - maxVisible + 1);
            }

            for (let i: any = start; i <= end; i++) {
                numbers.push(i);
            }
            return numbers;
        };

        const paginationNumbers = getPaginationNumbers();

        return (
            <section className="pcoded-main-container">
                <ToastsContainer
                    store={ToastsStore}
                    position={ToastsContainerPosition.TOP_RIGHT}
                />
                <div className="pcoded-wrapper">
                    <div className="pcoded-content">
                        <div className="pcoded-inner-content">
                            <div className="main-body">
                                <div className="page-wrapper">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card">
                                                <div className="card-header">
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <h5 className="file-status-header" style={{ margin: 0 }}>Received Query Mails</h5>
                                                    </div>
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '10px', flexWrap: 'wrap' }}>
                                                        <div style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
                                                            Total Files: <strong>{this.state.totalFiles}</strong> |
                                                            Files with Emails: <strong>{this.state.filesWithEmails}</strong> |
                                                            Total Emails: <strong>{this.state.totalEmails}</strong> |
                                                            Pending attachments: <strong>{this.state.totalAttachments}</strong>
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                                                            <span style={{ fontSize: '14px', color: '#666' }}>Branch:</span>
                                                            <select
                                                                value={branch_id}
                                                                onChange={this.handleBranchChange}
                                                                style={{
                                                                    padding: '5px 10px',
                                                                    border: '1px solid #ddd',
                                                                    borderRadius: '4px',
                                                                    fontSize: '14px',
                                                                    minWidth: '180px'
                                                                }}
                                                            >
                                                                <option value="">Select Branch</option>
                                                                {lawhandsBranches && lawhandsBranches.length
                                                                    ? lawhandsBranches.map((lawBranch: any) => (
                                                                        <option key={lawBranch.id} value={lawBranch.id}>
                                                                            {lawBranch.name}
                                                                        </option>
                                                                    ))
                                                                    : null}
                                                            </select>
                                                            <span style={{ fontSize: '14px', color: '#666' }}>Items per page:</span>
                                                            <select
                                                                value={limit}
                                                                onChange={this.handleLimitChange}
                                                                style={{
                                                                    padding: '5px 10px',
                                                                    border: '1px solid #ddd',
                                                                    borderRadius: '4px',
                                                                    fontSize: '14px'
                                                                }}
                                                            >
                                                                {this.limitList.map((item) => (
                                                                    <option key={item} value={item}>
                                                                        {item}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            <input
                                                                type="text"
                                                                value={searchText}
                                                                onChange={this.handleSearchInputChange}
                                                                onKeyDown={(e: any) => {
                                                                    if (e.key === "Enter") this.applySearch();
                                                                }}
                                                                placeholder="Search File No / App ID / Borrower Name"
                                                                style={{
                                                                    padding: '5px 10px',
                                                                    border: '1px solid #ddd',
                                                                    borderRadius: '4px',
                                                                    fontSize: '14px',
                                                                    minWidth: '260px'
                                                                }}
                                                            />
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-primary"
                                                                onClick={this.applySearch}
                                                                style={{ padding: '4px 10px', fontSize: '14px' }}
                                                            >
                                                                Search
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-secondary"
                                                                onClick={this.clearSearch}
                                                                style={{ padding: '4px 10px', fontSize: '14px' }}
                                                            >
                                                                Clear
                                                            </button>
                                                            {/* Bulk IMAP fetch replaced by webhook + inbound queue; keep method for emergencies.
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary"
                                                                onClick={this.fetchEmailsFromServer}
                                                                disabled={isFetchingEmails}
                                                                style={{
                                                                    marginTop: '0px',
                                                                    padding: '4px 10px',
                                                                    fontSize: '14px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '8px'
                                                                }}
                                                            >
                                                                {isFetchingEmails ? (
                                                                    <>
                                                                        <i className="fa fa-spinner fa-spin"></i>
                                                                        Fetching...
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <i className="fa fa-refresh"></i>
                                                                        Fetch Mail
                                                                    </>
                                                                )}
                                                            </button>
                                                            */}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    {isLoading ? (
                                                        <div style={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            minHeight: '200px'
                                                        }}>
                                                            <div className="spinner-border text-primary" role="status">
                                                                <span className="sr-only">Loading...</span>
                                                            </div>
                                                            <span style={{ marginLeft: '10px', color: '#666' }}>Loading files...</span>
                                                        </div>
                                                    ) : files.length === 0 ? (
                                                        <div style={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            minHeight: '200px',
                                                            flexDirection: 'column',
                                                            gap: '15px'
                                                        }}>
                                                            <p style={{ color: '#666', fontSize: '16px' }}>No files found</p>
                                                            {/* <button
                                                                type="button"
                                                                className="btn btn-outline-primary"
                                                                onClick={this.fetchEmailsFromServer}
                                                                disabled={isFetchingEmails}
                                                            >
                                                                {isFetchingEmails ? (
                                                                    <>
                                                                        <i className="fa fa-spinner fa-spin"></i>
                                                                        Fetching Emails...
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <i className="fa fa-refresh"></i>
                                                                        Fetch Emails from Server
                                                                    </>
                                                                )}
                                                            </button> */}
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <ReactFlexyTable
                                                                data={files}
                                                                columns={columns}
                                                                sortable
                                                                pagination={false}
                                                                className="Flexy-table-unhold salary-queue-report-table"
                                                                pageSize={limit}
                                                                showTotalRecords={false}
                                                            />
                                                            <div className="pagination-container" style={{
                                                                marginTop: '20px',
                                                                padding: '15px',
                                                                borderTop: '1px solid #eee',
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                flexWrap: 'wrap'
                                                            }}>
                                                                <div>
                                                                    <span style={{ fontSize: '14px', color: '#666' }}>
                                                                        Total data count: <strong>{totalDataCount}</strong>
                                                                    </span>
                                                                </div>
                                                                {noOfPages > 1 && (
                                                                    <nav aria-label="Page navigation">
                                                                        <ul className="pagination justify-content-center" style={{ margin: 0 }}>
                                                                            {/* First Page */}
                                                                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                                                <button
                                                                                    className="page-link"
                                                                                    onClick={() => this.handlePageChange(null, 1)}
                                                                                    disabled={page === 1}
                                                                                >
                                                                                    &laquo;
                                                                                </button>
                                                                            </li>

                                                                            {/* Previous Page */}
                                                                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                                                <button
                                                                                    className="page-link"
                                                                                    onClick={() => this.handlePageChange(null, page - 1)}
                                                                                    disabled={page === 1}
                                                                                >
                                                                                    &lsaquo;
                                                                                </button>
                                                                            </li>

                                                                            {/* Page Numbers */}
                                                                            {paginationNumbers.map((num) => (
                                                                                <li key={num} className={`page-item ${page === num ? 'active' : ''}`}>
                                                                                    <button
                                                                                        className="page-link"
                                                                                        onClick={() => this.handlePageChange(null, num)}
                                                                                    >
                                                                                        {num}
                                                                                    </button>
                                                                                </li>
                                                                            ))}

                                                                            {/* Next Page */}
                                                                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                                                <button
                                                                                    className="page-link"
                                                                                    onClick={() => this.handlePageChange(null, page + 1)}
                                                                                    disabled={page === totalPages}
                                                                                >
                                                                                    &rsaquo;
                                                                                </button>
                                                                            </li>

                                                                            {/* Last Page */}
                                                                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                                                <button
                                                                                    className="page-link"
                                                                                    onClick={() => this.handlePageChange(null, totalPages)}
                                                                                    disabled={page === totalPages}
                                                                                >
                                                                                    &raquo;
                                                                                </button>
                                                                            </li>
                                                                        </ul>
                                                                    </nav>
                                                                )}
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* THIS FOR OUT REASON MODAL */}
                <div
                    className="modal fade hide in"
                    id="out_reason"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog ">
                        <div
                            className="modal-content"
                            style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
                        >
                            <div
                                className="modal-body"
                                style={{ padding: "30px 23px 29px 24px" }}
                            >
                                <h3 style={{ margin: "auto", fontSize: "17px" }}>
                                    Please Select The Reason For To Close The File.No:
                                    {localStorage.getItem("currentfileId")}
                                </h3>
                            </div>
                            <div
                                className="form-group"
                                style={{ width: "74%", margin: "auto" }}
                            >
                                <select
                                    className="custom-select"
                                    name="outreason"
                                    value={this.state.outreason}
                                    onChange={(e) => this.onchangeReason(e)}
                                    required
                                    id="select1"
                                    style={{ marginTop: "8px" }}
                                >
                                    <option value="select">Select Your Reason</option>
                                    <option value="Query Raised">Query Raised</option>
                                    <option value=" Re-Query Raised"> Re-Query Raised</option>
                                    <option value="Hold ">Hold </option>
                                    <option value="Completed">Completed</option>
                                    <option value="Other">Others</option>
                                </select>
                                {selectVal ? (
                                    <p
                                        style={{
                                            color: "red",
                                            textAlign: "center",
                                            fontSize: "16px",
                                        }}
                                    >
                                        Please Select Your Reason{" "}
                                    </p>
                                ) : null}
                            </div>
                            <div className="modal-footer" style={{ marginTop: "27px" }}>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={this.state.isLoading}
                                    onClick={this.outimeGet}
                                    style={{ width: "76px", fontSize: "17px" }}
                                >
                                    {" "}
                                    {this.state.isLoading ? (
                                        <i className="fa fa-spinner fa-spin"></i>
                                    ) : (
                                        "OK"
                                    )}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline"
                                    onClick={this.BacktoFile}
                                    style={{
                                        width: "107px",
                                        fontSize: "14px",
                                        border: "1px solid black",
                                        height: "43px",
                                    }}
                                >
                                    {" "}
                                    Back To File
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="modal hide fade in"
                    id="another-reason"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog ">
                        <div
                            className="modal-content"
                            style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
                        >
                            <h5 style={{ marginTop: "31px", textAlign: "center" }}>
                                Please Type a Reason To Close The File.No:{" "}
                                {localStorage.getItem("currentfileId")}{" "}
                            </h5>
                            <div
                                className="modal-body"
                                style={{ padding: "30px 23px 29px 24px" }}
                            >
                                <div
                                    className="form-group"
                                    style={{ width: "98%", margin: "auto" }}
                                >
                                    <textarea
                                        className="form-control"
                                        placeholder="Type Your Reason"
                                        name="outreason"
                                        onChange={this.onchange}
                                    />
                                    {selectVal ? (
                                        <p
                                            style={{
                                                color: "red",
                                                textAlign: "center",
                                                fontSize: "16px",
                                            }}
                                        >
                                            Please Select Your Reason{" "}
                                        </p>
                                    ) : null}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => this.outimeGet()}
                                    style={{ width: "76px", fontSize: "17px" }}
                                    disabled={this.state.isLoading}
                                >
                                    {this.state.isLoading ? (
                                        <i className="fa fa-spinner fa-spin"></i>
                                    ) : (
                                        "OK"
                                    )}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline"
                                    onClick={() => this.previousPop()}
                                    style={{
                                        width: "76px",
                                        fontSize: "17px",
                                        border: "1px solid black",
                                    }}
                                >
                                    {" "}
                                    Back
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default ReceivedQueryMail;